import API from '@/services/API'
import store from '@/store/store'

export default {
	async get (username, options) {
		try {
			const response = await API.get(`/user/${username}`, {
				params: options,
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			const profile = response.data.user
			return profile
		} catch (err) {
			console.log(err)
		}
	},
	async getUsers () {
		try {
			const response = await API.get('user/index', {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return response.data.users
		} catch (err) {
			console.log(err)
		}
	},
	async edit (user) {
		try {
			await API.post(`user/${user.username}`, user, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
		} catch (err) {
			console.log(err)
		}
	},
	async deleteUser (username) {
		try {
			await API.delete(`user/${username}`, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
		} catch (err) {
			console.log(err)
		}
	},
	async befriend (username) {
		try {
			await API.post(`user/social/befriend`, { username }, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
		} catch (err) {
			console.log(err)
		}
	},
	async unfriend (username) {
		try {
			await API.post(`user/social/unfriend`, { username }, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
		} catch (err) {
			console.log(err)
		}
	},
	async getFriendRequests () {
		try {
			const response = await API.get(`user/social/friend-requests`, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return response.data.requests
		} catch (err) {
			console.log(err)
		}
	},
	async getFriends (username) {
		try {
			const response = await API.get(`user/social/friends/${username}`, {
				headers: {
					Authorization: `Bearer ${store.state.authentication.token}`
				}
			})
			return response.data.friends
		} catch (err) {
			console.log(err)
		}
	}
}
